import React from 'react';
import classNames from 'classnames';

interface SkeletonProps {
  className?: string;
  height?: string;
  width?: string;
}

function Skeleton({ className, width, height }: SkeletonProps) {
  return (
    <div
      className={classNames('skeleton', className)}
      style={{ width, height }}
    />
  );
}

export default Skeleton;
